import { defineModule } from "@motolynk/app-core";

import { NotificationsBell } from "./components/NotificationsBell";
import en from "./i18n/en.json";

const bell = { id: "notifications.bell", component: NotificationsBell, order: 10 };
const allPage = { path: "notifications", page: () => import("./pages/NotificationsPage") };
const allLink = {
  id: "notifications",
  label: "notifications:nav.all",
  icon: "inbox" as const,
  to: "/notifications",
};

export const notificationsModule = defineModule({
  name: "notifications",
  label: "Notifications",
  requires: ["core", "accounts"], // frontend bundle needs only these (backend: + configuration, audit)
  i18n: { en },
  // The bell in every panel, the full list (P5-08); the admin's settings and message log.
  admin: {
    topbar: [bell],
    userMenu: [allLink],
    routes: [
      allPage,
      {
        path: "settings/notifications",
        permission: "notifications.view_notificationsetting",
        page: () => import("./pages/SettingsPage"),
      },
      {
        path: "settings/notifications/log",
        permission: "notifications.view_notificationlog",
        page: () => import("./pages/LogPage"),
      },
    ],
    nav: [
      {
        id: "notification-settings",
        group: "settings",
        label: "notifications:nav.settings",
        icon: "megaphone",
        to: "/settings/notifications",
        permission: "notifications.view_notificationsetting",
        order: 7,
      },
      {
        id: "notification-log",
        group: "reports",
        label: "notifications:nav.log",
        icon: "mail",
        to: "/settings/notifications/log",
        permission: "notifications.view_notificationlog",
        order: 2,
      },
    ],
  },
  vendor: { topbar: [bell], userMenu: [allLink], routes: [allPage] },
});
